import React, { useState } from 'react';
import NavColListItem from './nav-col-list-item';
import StyledLink from '../../../components/StyledLink/StyledLink';

const NavCol = ({ additionClass, isLastItem, items, colId, colTitle, titleId, titleHref }) => {
  const [activeSubmenuId, setActiveSubmenuId] = useState('');
  const handleSubmenuId = (id) => {
    setActiveSubmenuId(id);
  };

  return (
    <div className={`nav__dropdown-col ${additionClass ? additionClass : ''} ${isLastItem ? 'nav__dropdown-border' : ''}`}>
      {colTitle ? (
        titleHref ? (
          <StyledLink id={titleId} fontWeight="700" color="#606e7b" fontSize="13px" href={titleHref}>
            {colTitle}
          </StyledLink>
        ) : (
          <p id={titleId}>{colTitle}</p>
        )
      ) : (
        <div className={'nav__dropdown-spacer'} />
      )}
      <ul className={`nav__links`}>
        {items &&
          items.map(
            (
              { href, img, width, height, linkText, subText, title, headId, subTextId, iconId, subMenu, additionalClass, insideTitle },
              idxItem
            ) => {
              const ifIsIntegrations = href === '/integrations';
              const isEnInBuild = process.env.REACT_APP_CURRENT_BUILD === 'en-in';

              return isEnInBuild && ifIsIntegrations ? (
                <></>
              ) : (
                <NavColListItem
                  titleId={headId}
                  subTextId={subTextId}
                  iconId={iconId}
                  key={`${colId}_item_${idxItem}`}
                  href={href}
                  additionalClass={additionalClass}
                  img={img}
                  width={width}
                  height={height}
                  linkText={linkText}
                  subtext={subText}
                  title={title}
                  subMenu={subMenu}
                  activeSubmenuId={activeSubmenuId}
                  handleSubmenuId={handleSubmenuId}
                  insideTitle={insideTitle}
                />
              );
            }
          )}
      </ul>
    </div>
  );
};

export default NavCol;
